import { render, staticRenderFns } from "./CustomFileInput.vue?vue&type=template&id=a770b190&"
import script from "./CustomFileInput.vue?vue&type=script&lang=js&"
export * from "./CustomFileInput.vue?vue&type=script&lang=js&"
import style0 from "./CustomFileInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
